import RequirementController from '../../../controllers/requirementController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default {
    name: 'SimpleTable',
    data(){
        return{
          company: '',
          requirementList: [],
          searchQuery: '',
          currentPage: 1,
          pageSize: 10,
          totalPages: 0,
          totalRequirements: 0,
          requirement: {
              requirement: '',
              status: '',
              created_by: '',
              created_by_name: '',
              created_on: '',
          },
          selectedRequirement: {
              updated_by: '',
              updated_by_name: '',
              updated_on: '',
          }
        }
    },
    computed: {
        filteredRequirements() {
            return this.requirementList.filter(requirement => {
                return requirement.requirement.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        },
        pages(){
            return Math.ceil(this.totalRequirements / this.pageSize);
        },
        displayedPages(){
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
  
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
  
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
      user(){
        const user = localStorage.getItem('user');
        const id = JSON.parse(user).mst_employee_id;
        this.requirement.created_by = id;
        this.selectedRequirement.updated_by = id;
        const name = JSON.parse(user).mst_employee_name;
        this.requirement.created_by_name = name;
        this.selectedRequirement.updated_by_name = name;
      },
      showModal(type, id) {
        this.user();
        const requirement = this.requirementList.find(requirement => requirement.id === id);
        if (requirement) {
          this.requirement = requirement;
  
          const modal = document.getElementById(type === 'edit' ? 'editRequirement' : 'detailRequirement');
  
          modal.style.display = 'block';
          requestAnimationFrame(() => {
            modal.classList.add('show');
          });
  
          document.body.classList.add('modal-open');
  
          const backdrop = document.createElement('div');
          backdrop.classList.add('modal-backdrop', 'fade');
          document.body.appendChild(backdrop);
  
          requestAnimationFrame(() => {
            backdrop.classList.add('show');
          });
        }
      },
      closeModal() {
        const modalIds = ['tambahRequirement', 'editRequirement', 'detailRequirement'];
        modalIds.forEach(id => {
          const modal = document.getElementById(id);
          if (modal && modal.classList.contains('show')) {
            modal.classList.remove('show');
            setTimeout(() => {
              modal.style.display = 'none';
            }, 300);
          }
        });
      
        // Hapus backdrop
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.classList.remove('show');
          setTimeout(() => {
            if (backdrop.parentNode) {
              backdrop.parentNode.removeChild(backdrop);
            }
          }, 300);
        });
      
        // Hapus kelas atau atribut yang mengunci scroll pada body
        const body = document.body;
        body.classList.remove('modal-open');
        body.style.overflow = ''; // Menghapus properti overflow jika ada
        this.getRequirement();
        this.resetForm();
        this.user();
      },  
      resetForm() {
        this.requirement.requirement = '';
        this.requirement.status = '';  
      },
      changePage(page) {
        if (page > 0 && page <= this.pages) {
          this.currentPage = page;
          this.getRequirement();
        }
      },
      async getRequirement(){
          try {
            const company = this.company;
            const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
            const response = await RequirementController.getRequirement(query, this.currentPage, this.pageSize, company);
            this.requirementList = response.data;
            this.totalAllRequirements();
          } catch (error) {
            console.error('Error fetching requirements:', error);
            throw error;
          }
      },
      async addRequirement() {
        try {
          const { requirement, status: is_active, created_by, created_by_name } = this.requirement;
          const created_on = new Date().toISOString().slice(0, 19).replace('T', ' '); // Format MySQL

          if (!requirement || !is_active || !created_by || !created_by_name) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Isi semua field!!',
              timer: 1500
            });
            return;
          }
          const id_company = this.company;

          const add = {
            requirement,
            is_active,
            id_company,
            created_by,
            created_by_name,
            created_on
          };

          const response = await RequirementController.addRequirement(add);
          if (response.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil menambahkan data',
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Gagal menambahkan data',
              timer: 1500
            });
          }

          this.closeModal();
          this.getRequirement();
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Gagal menambahkan data',
            text: error.message,
            timer: 1500
          });
        }
      },
      async totalAllRequirements() {
          try {
            const company = this.company;
            const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
            const response = await RequirementController.totalAllRequirements(query, company);
            this.totalRequirements = response.data;
          } catch (error) {
              console.error('Error geting requirements:', error);
          }
      },
      async updateRequirement() {
        try {
          const { updated_by, updated_by_name } = this.selectedRequirement;
          const { id, requirement, status } = this.requirement;
          const now = new Date();
          const updated_on = now.toISOString().slice(0, 19).replace('T', ' '); // Format MySQL
          if (!requirement || !status || !updated_by || !updated_by_name) {
            throw new Error('Isi semua field!!');
          }
          const updated = {
            id,
            requirement,
            is_active: this.requirement.status,
            updated_by,
            updated_by_name,
            updated_on
          };
          const response = await RequirementController.updateRequirement(updated);
          if (response.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil mengubah data',
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Gagal mengubah data',
              timer: 1500
            });
            return;
          }
          this.closeModal();
          this.getRequirement();
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Gagal mengubah data',
            text: error.message,
            timer: 1500
          });
        }
      },
      async deleteRequirement(id){
        const confirmed = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                return true;
            }
            return false;
        });
        if (confirmed) {
          try {
            await RequirementController.deleteRequirement(id);
            Swal.fire({
              icon: 'success',
              title: 'Berhasil menghapus data',
              timer: 1500
            })
            this.getRequirement();
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Gagal menghapus data',
              text: error.message,
              timer: 1500
            })
            return;
          }
        }
      },
      onCompanyChange(newCompany) {
        this.company = newCompany;
      }
    },
    mounted(){
      this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'getRequirement'
        },
        company: {
            handler: 'getRequirement'
        }
    },
}